const PATH = "/api/v1/discover";

const ENDPOINTS = {
  DISCOVER_SEED: "/seed/",
  DISCOVER_APP_SEED:"/app/seed/",
  DISCOVER_CARDS: "/discover_cards/",
  POPULAR_PROPERTIES: "/featured_operators/",
  DISCOVER_EXPERIENCE: "/experience/",
  DISCOVER_EXPERIENCES: "/experiences/",
  DISCOVER_DESTINATION: "/destination/",
  DISCOVER_HOME: "/home/",
  DISCOVER_PLAYLISTS: "/playlists/",
  DISCOVER_PLAYLIST: "/playlist/",
};

export type DiscoverEndpoints = keyof typeof ENDPOINTS;
export const DiscoverCollection = { PATH, ENDPOINTS };
